import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "../brand/Logo";

export default function Cancelled() {
  const [params] = useSearchParams();
  const pi = params.get("pi");

  return (
    <main data-testid="cancelled-page" className="min-h-screen bg-bone text-ink flex flex-col">
      <div className="px-6 md:px-12 lg:px-16 py-8">
        <Logo variant="compact" />
      </div>
      <div className="flex-1 flex items-center">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24 w-full">
          <XCircle className="w-14 h-14 text-ink/60 mb-8" strokeWidth={1.5} />
          <div className="overline text-inkmute mb-4">Payment cancelled</div>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tight leading-[1.02]">
            No worries —
            <br />
            <span className="font-wordmark italic font-semibold text-ink/85">
              try again whenever.
            </span>
          </h1>
          <p className="mt-6 text-ink/75 text-lg leading-relaxed max-w-xl">
            Your card hasn’t been charged. If something didn’t feel right at
            checkout, send us a note and we’ll sort it.
          </p>

          {pi && (
            <p className="mt-6 text-sm text-inkmute" data-testid="cancelled-reference">
              Reference: <span className="font-semibold text-ink">{pi}</span>
            </p>
          )}

          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/#products"
              data-testid="cancelled-retry-link"
              className="inline-flex items-center gap-2 bg-ink text-bone hover:bg-terracotta transition-colors duration-300 px-6 py-3.5 rounded-sm font-display font-semibold text-sm"
            >
              Back to products
            </Link>
            <Link
              to="/"
              data-testid="cancelled-home-link"
              className="inline-flex items-center gap-2 text-ink hover:text-terracotta overline link-underline"
            >
              <ArrowLeft className="w-4 h-4" />
              Home
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
